// extracted by mini-css-extract-plugin
export default {"overlay":"WSOverlay-module_overlay-azWRU","white":"WSOverlay-module_white-yjw4I"};